
    
    //namespaced: true,
    const  initFilter={
        current_tab:"",
        current_period:"daily",
        date:"",
        manulSelectedTab:"",
        filterData:{
        owners:[],
        contracts:[],
        groups: [],
        types:[],
        device_categories:[],

       
        }

  }

const windowFoucs=true;

  const initialState = () => {
    return  Object.assign({}, initFilter)
    
  }
const state = initialState()
const  actions= {
     setDashBoardFilterData (ctx, params) {   
      
      
        ctx.commit('setDashBoardFilterData',params);  
      
    },
    setDashboardCurrentTab(ctx,val){
      ctx.commit('setDashboardCurrentTab',val);  
    },
    setDashboardCurrentPeriod(ctx,val){
      ctx.commit('setDashboardCurrentPeriod',val);  
    },
    setDashBoardFilterDate(ctx,val){
      ctx.commit('setDashBoardFilterDate',val);  
    },
    setWindowFoucs(ctx,val){
      ctx.commit('setWindowFoucs',val)
    },
    setManulSelectedTab(ctx,val){
      ctx.commit('setManulSelectedTab',val)
    }
    

}
const mutations={
    setDashBoardFilterData:(state,data)=>{  
       Object.assign(state.filterData,data)
      },

      setDashboardCurrentTab:(state,val)=>{
         state.current_tab=val;
      },
      setDashboardCurrentPeriod:(state,val)=>{
        if(val==false){
          state.current_period="daily"
        }else{
          state.current_period=val;
        }
       
     },
     setDashBoardFilterDate:(state,val)=>{
    
       state.date=val;
     },

      setWindowFoucs(state,data){
       
        state.windowFoucs=data;
      },
      setManulSelectedTab(state,data){
        state.manulSelectedTab=data;
      }

   
 
}
const getters={
  getFilterData(state) {
    
  return state.filterData
  },
  getCurrentTab(state){

    return state.current_tab;
  },
  getWindowFoucs(state){
   return windowFoucs;
  },
  getManulSelectedTab(state){
    return state.manulSelectedTab;
  }
  }








export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };